import {ListModel, PaginationModel} from "../models";
import {PaginatedResponse} from "../services";

// TODO: implement decorator for showing the errors in the console.
// (errors happening in React Query's query.select callback are silent and need to explicitly specify try-catch when debugging).

export abstract class TransformBase {
  protected same<T>(dtoOrModel: T): T {
    return dtoOrModel;
  }
}

export abstract class ManagementTransformBase<
  T,
  P extends boolean = true,
> extends TransformBase {
  abstract makeRecordModel(dto: unknown): T;

  // TODO: make protected method as soon as standardized backends API's list interface.
  // Do this after couple of list API integrations.
  abstract makeListModel(dto: unknown): ListModel<T, P>;

  protected makePaginationModel(dto: PaginatedResponse): PaginationModel {
    const model: PaginationModel = {
      size: dto.page_size,
      current: dto.page_number,
      pagesCount: Math.ceil(dto.total / dto.page_size),
      totalCount: dto.total,
    };

    return model;
  }
}
